import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnKY: CultureInfo = {
  name: 'en-KY',
  displayName: 'English (Cayman Islands)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-KY',
  parent: CultureInfoEn
};
